import React from "react";
import { useDispatch } from "react-redux";
import { Card, Button } from "react-bootstrap";
import { setProfileView } from "../redux/Actions";
import { COMPANY, DIVISION, EMPLOYEE_DEPARTMENT, EMPLOYEE_STATUS, EMPLOYEE_TYPE, HIRE_STATUS, JOB_TITLE, MARKET, REGION, STORE } from "../../../shared/constants/Constants";
import "./ProfileView.scss";

const ProfileView = () => {
  const dispatch = useDispatch();
  const employee = JSON.parse(localStorage.getItem("employee") || "{}");

  const handleBackToReports = () => {
    dispatch(setProfileView(false));
  };

  return (
    <div className="profile-view-container">
      <div className="profile-view-header">
        <Button
          variant="link"
          className="back-to-reports-btn"
          onClick={handleBackToReports}
        >
          <i className="fa fa-arrow-left"></i> Back to Reports
        </Button>
        <h2 className="profile-view-title">
          <i className="fa fa-user me-2"></i>
          My Profile
        </h2>
      </div>

      <Card className="profile-card">
        <Card.Body>
          {/* Personal Information */}
          <div className="profile-section">
            <h5 className="profile-section-title">Personal Information</h5>
            <div className="profile-grid">
              <div className="profile-field">
                <dt>Emp. Number</dt>
                <dd>{employee?.employee_id || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>First Name</dt>
                <dd>{employee?.first_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Last Name</dt>
                <dd>{employee?.last_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Preferred Name</dt>
                <dd>{employee?.preferred_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>NTID</dt>
                <dd>{employee?.ntid || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>C Number</dt>
                <dd>{employee?.cnumber || "N/A"}</dd>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="profile-section">
            <h5 className="profile-section-title">Contact Information</h5>
            <div className="profile-grid">
              <div className="profile-field">
                <dt>Work Email</dt>
                <dd>{employee?.email_work || employee?.email || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Personal Email</dt>
                <dd>{employee?.email_personal || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Work Phone</dt>
                <dd>{employee?.work_phone || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Personal Phone</dt>
                <dd>{employee?.personal_phone || "N/A"}</dd>
              </div>
              <div className="profile-field profile-field-full">
                <dt>Home Address</dt>
                <dd>{employee?.home_address || "N/A"}</dd>
              </div>
            </div>
          </div>

          {/* Job Information */}
          <div className="profile-section">
            <h5 className="profile-section-title">Job Information</h5>
            <div className="profile-grid">
              <div className="profile-field">
                <dt>{JOB_TITLE}</dt>
                <dd>{employee?.job_title_name || employee?.job_title || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{EMPLOYEE_DEPARTMENT}</dt>
                <dd>{employee?.department_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Hire Date</dt>
                <dd>{employee?.hire_date || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Termination Date</dt>
                <dd>
                  {employee?.term_date === "12-31-2099" || !employee?.term_date
                    ? "N/A"
                    : employee?.term_date}
                </dd>
              </div>
              <div className="profile-field profile-field-full">
                <dt>Termination Reason</dt>
                <dd>{employee?.term_reason || "N/A"}</dd>
              </div>
            </div>
          </div>

          {/* Location & Employment */}
          <div className="profile-section">
            <h5 className="profile-section-title">Location & Employment</h5>
            <div className="profile-grid">
              <div className="profile-field">
                <dt>{EMPLOYEE_TYPE}</dt>
                <dd>{employee?.full_part_time_status || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{HIRE_STATUS}</dt>
                <dd>{employee?.hire_status_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{STORE}</dt>
                <dd>{employee?.store_sap_name || employee?.store_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{MARKET}</dt>
                <dd>{employee?.market_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{REGION}</dt>
                <dd>{employee?.region_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{DIVISION}</dt>
                <dd>{employee?.division_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{COMPANY}</dt>
                <dd>{employee?.company_name || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>{EMPLOYEE_STATUS}</dt>
                <dd>{employee?.emp_status || "N/A"}</dd>
              </div>
              <div className="profile-field">
                <dt>Commissionable</dt>
                <dd>
                  {employee?.is_commisionable ? (
                    <i className="fa fa-check-circle text-success"></i>
                  ) : (
                    <i className="fa fa-times-circle text-muted"></i>
                  )}
                </dd>
              </div>
              {/* <div className="profile-field profile-field-full">
                <dt>Supervisor</dt>
                <dd>
                  {employee?.supervisor_first_name || employee?.supervisor_last_name || employee?.supervisor_employee_id
                    ? `${employee?.supervisor_first_name ?? ""} ${employee?.supervisor_last_name ?? ""}${employee?.supervisor_employee_id ? `, ${employee.supervisor_employee_id}` : ""}`
                    : "N/A"}
                </dd>
              </div> */}
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProfileView;
